// @secure
export enum WidgetType {
  TransactionNumber = 'transactionNumber',
  Cashback = 'cashback',
  Revenue = 'revenue',
  RefundAmount = 'refundAmount',
  AverageBasket = 'averageBasket',
  TransactionRevenueChart = 'transactionRevenueChart',
  TerminalConnections = 'terminalConnections',
  CustomerMerchantCount = 'customerMerchantCount',
  CustomerPoiCount = 'customerPoiCount',
  CustomerAverageRevenue = 'customerAverageRevenue',
  TerminalsOverQuota = 'terminalsOverQuota',
  MaintainerTerminalsWithoutTelecollectCount = 'maintainerTerminalsWithoutTelecollectCount',
  MaintainerActiveTerminalsCount = 'maintainerActiveTerminalsCount',
  ActiveSimsCount = 'activeSimsCount',
  ComparisonAverageBasket = 'comparisonAverageBasket',
  ComparisonCount = 'comparisonCountChart',
  ComparisonAmount = 'comparisonAmountChart',
  PaymentMethodsAmount = 'paymentMethodsAmount',
  CardAverageBasket = 'cardAverageBasket',
  PaymentMethodsCount = 'paymentMethodsCount',
  CardsCount = 'cardsCount',
  WalletsAmount = 'walletsAmount',
  WalletsCount = 'walletsCount',
  CardsAmount = 'cardsAmount',
  WalletAverageBasket = 'walletAverageBasket',
  CustomersCountPieChart = 'customersCountPieChart',
  CustomersTransactionCountPieChart = 'customersTransactionCountPieChart',
  CustomersAverageVisitsBadge = 'customersAverageVisitsBadge',
  CustomersAverageBasketBarChart = 'customersAverageBasketBarChart',
  CustomersTopByAmount = 'customersTopByAmount',
  CustomersTopByCount = 'customersTopByCount',
  TerminalVolumesPer = 'terminalVolumesPer',
  SimVolumesPer = 'SimVolumesPer',
  GrossRevenue = 'grossRevenue',
  NetRevenuePerTerminal = 'netRevenuePerTerminal'
}

export const WidgetWithCurrency = [
  WidgetType.NetRevenuePerTerminal,
  WidgetType.GrossRevenue,
  WidgetType.Revenue,
  WidgetType.Cashback,
  WidgetType.AverageBasket,
  WidgetType.CustomerAverageRevenue,
  WidgetType.TransactionRevenueChart,
  WidgetType.ComparisonAmount,
  WidgetType.ComparisonAverageBasket,
  WidgetType.CardsAmount,
  WidgetType.WalletsAmount,
  WidgetType.PaymentMethodsAmount,
  WidgetType.CardAverageBasket,
  WidgetType.WalletAverageBasket
];

export const WidgetWithPalette = [
  WidgetType.TransactionRevenueChart,
  WidgetType.ComparisonCount,
  WidgetType.ComparisonAmount,
  WidgetType.ComparisonAverageBasket,
  WidgetType.CardsAmount,
  WidgetType.CardsCount,
  WidgetType.WalletsAmount,
  WidgetType.WalletsCount,
  WidgetType.PaymentMethodsAmount,
  WidgetType.PaymentMethodsCount,
  WidgetType.CardAverageBasket,
  WidgetType.WalletAverageBasket
];

export const BigWidgets = {
  [WidgetType.TransactionRevenueChart]: {
    xs: 12,
    md: 12,
    lg: 12,
    xl: 12
  },
  [WidgetType.ComparisonCount]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  },
  [WidgetType.ComparisonAverageBasket]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  },
  [WidgetType.ComparisonAmount]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  },
  [WidgetType.PaymentMethodsCount]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  },
  [WidgetType.CardsCount]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  },
  [WidgetType.WalletsAmount]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  },
  [WidgetType.WalletsCount]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  },
  [WidgetType.CardsAmount]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  },
  [WidgetType.CardAverageBasket]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  },
  [WidgetType.WalletAverageBasket]: {
    xs: 12,
    md: 8,
    lg: 8,
    xl: 6
  }
};

export const getWidgetSpecificSize = (type) => {
  return BigWidgets[type] ?? { xs: 6, md: 4, lg: 4, xl: 3 };
};
